window.rate = 300;
window.extra = 0;

// debug print
function print(name, value) {
  console.log(name, ": ", value);
}

// on change product
// $("#listen-id").on("change", function () {
//   const product = $(this).find("option").filter(":selected");
//   $("#selected-title").text(product.text());
//   $("#product-id").val(product.data("id"));
//   $("#product-price").val(product.data("price"));
//   calc();
// });

// on change pumping
// $("#pumping").on("change", calc);

// on change tax
// $("#tax").on("change", calc);

// on add to cart click
// $("#add-to-cart").on("click", applyCart);

// on change qty
// $("#qty").on("change paste keyup", function () {
//   var value = this.value;
//   if (value == "") {
//     value = "1";
//   }
//   $("#product-qty").val(value);
//   calc();
// });

// on change zip code
// $("#zipcode").on("change paste keyup", function () {
//   if (this.value.length == 5) calc_rates(this.value, calc);
// });

// get product id
function getProductId() {
  return $("#product-id").val();
}

// get product price
function getProductPrice() {
  const value = $("#product-price").val();
  return parseFloat(value.replace("$", ""));
}

// calc total
function calc() {
  var cost = getProductPrice();
  const qty = parseInt($("#product-qty").val());
  const multiply = calcMultiply(qty);

  const rate = (window.rate || 0) * multiply;
  const pumping = document.getElementById("pumping").checked;
  const tax = document.getElementById("tax").checked;

  print("product cost with no tax", cost);

  if (!tax) {
    cost += cost * 0.095;
  }

  print("product sum with tax", cost);

  let sum = cost * qty;

  // 1-5(20%)
  // 5-10(18%)
  // 10-20(15%)
  // 20-50(12%)
  // 50-100(10%)

  //  window.extra = 0;
  //     if (qty >= 1 && qty <= 5 ) {
  //         window.extra = (sum * 0.20);
  //     } else if (qty > 5 && qty <= 10) {
  //         window.extra = (sum * 0.18);
  //     } else if (qty > 10 && qty <= 20) {
  //         window.extra = (sum * 0.15);
  //     } else if (qty > 20 && qty <= 50) {
  //      window.extra = (sum * 0.12);
  //     } else if (qty > 50 && qty <= 100) {
  //         window.extra = (sum * 0.10);
  //     }

  print("product sum with extra", sum);
  print("product cost", cost);
  print("product qty", qty);
  print("product multiply", multiply);
  print("product rate", rate);
  print("product pumping", pumping);
  print("product tax", tax);
  print("product extra", window.extra);

  // 55 - enviromental fee
  sum += rate + 55 * multiply; //  + window.extra

  // 300 - pump and delivery
  // 13 - pump
  if (pumping) {
    sum += 300;
    sum += 13 * qty;
  }

  print("product pumping price", 13 * qty);

  sum = (Math.round(sum * 100) / 100).toFixed(2);
  const extraFull = Math.ceil(window.extra);
  $("#calc-result").text("$" + sum);

  var more = "";

  if (pumping) {
    more = `<b>Approximatly price includes</b> <br> <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> Environmental fee: <span style="border-bottom: 1px solid rgb(247, 99, 5);">$55x${multiply}</span><br>
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> CONCRETE (<span style="border-bottom: 1px solid rgb(247, 99, 5);">${$(
                "#selected-title"
              ).text()}</span>): <span style="border-bottom: 1px solid rgb(247, 99, 5);">$${cost.toFixed(
      2
    )}x${qty}</span><br>
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> Cost of Pumping: <span style="border-bottom: 1px solid rgb(247, 99, 5);">$13x${qty}</span><br>
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> PUMP delivery and set up: <span style="border-bottom: 1px solid rgb(247, 99, 5);">$300</span><br>
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> Local Delivery: <span style="border-bottom: 1px solid rgb(247, 99, 5);">$${
                window.rate
              }x${multiply}</span>`;
  } else {
    more = `<b>Approximatly price includes</b> <br> <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> Environmental fee: <span style="border-bottom: 1px solid rgb(247, 99, 5);">$55x${multiply}</span><br>
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> CONCRETE (<span style="border-bottom: 1px solid rgb(247, 99, 5);">${$(
                  "#selected-title"
                ).text()}</span>): <span style="border-bottom: 1px solid rgb(247, 99, 5);">$${cost.toFixed(
      2
    )}x${qty}</span><br>
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43192 9.2502C4.88786 9.83961 4.00508 9.83961 3.46128 9.2502L0.408044 5.94245C-0.136015 5.35333 -0.136015 4.39696 0.408044 3.80783C0.951839 3.21842 1.83462 3.21842 2.37868 3.80783L4.19781 5.77831C4.33514 5.9268 4.55806 5.9268 4.69565 5.77831L9.62132 0.442057C10.1651 -0.147352 11.0479 -0.147352 11.592 0.442057C11.8532 0.725098 12 1.10912 12 1.50937C12 1.90961 11.8532 2.29363 11.592 2.57667L5.43192 9.2502Z"fill="#f26522"/></svg> Local Delivery: <span style="border-bottom: 1px solid rgb(247, 99, 5);">$${
                  window.rate
                }x${multiply}</span>`;
  }
  $(".more").html(more);
}

function calcMultiply(num) {
  if (num === 0) return 1;
  const base = [...Array(100).keys()];
  const numbers = base.map((n) => n * 10);

  var index = numbers.indexOf(num);
  if (index !== -1) {
    return base[index];
  }
  return Math.floor(num / 10) + 1;
}

// apply cart
function applyCart() {
  const productId = getProductId();
  const productqty = Math.ceil($("#product-qty").val());
  const multiply = calcMultiply(productqty);
  const checkedPumping = document.getElementById("pumping").checked;

  var data = [
    {
      id: productId,
      quantity: productqty,
    },
  ];

  // pump and delivery setup
  if (checkedPumping) {
    data.push({
      id: 42564774887590,
      quantity: 1,
    });

    // pumping
    data.push({
      id: 42639736897702,
      quantity: productqty,
    });
  }

  // environmental  fee
  data.push({
    id: 42564762075302,
    quantity: multiply,
  });

  // extra charge
  //    const qty_extra = Math.ceil(window.extra);

  //     if (qty_extra > 0) {
  //        data.push({
  //          'id': 42564795859110,
  //         'quantity': qty_extra
  //       })
  //     }

  window.Shopify.clear((r) => {
    $.post("/cart/add.js", {
      items: data,
      success: function (r) {
        setTimeout(() => {
          window.location.href = `/cart`;
        }, 1000);
      },
    });
  });
}

// calc rate
function calc_rates(zip, callback) {
  var service = new google.maps.DistanceMatrixService();
  service.getDistanceMatrix(
    {
      origins: ["Los Angeles, CA 91352, USA"],
      destinations: [`Los Angeles, ${zip}, USA`],
      travelMode: "DRIVING",
      unitSystem: google.maps.UnitSystem.IMPERIAL,
    },
    callback
  );

  function callback(response, status) {
    let value = parseInt(response.rows[0].elements[0].distance.value) / 1609.34;

    // 0-7 300
    // 7-12 350
    // 12-20 400
    // 20-27 450
    // 27-40 500

    // new 22.04.22

    // 0-8 300
    // 8-15 350
    // 15-20 400
    // 20-27 450
    // 27-40 500

    if (value <= 8 && value > 0) {
      window.rate = 300;
    } else if (value <= 15 && value > 8) {
      window.rate = 350;
    } else if (value <= 20 && value > 15) {
      window.rate = 400;
    } else if (value <= 27 && value > 20) {
      window.rate = 450;
    } else if (value <= 100 && value > 27) {
      window.rate = 500;
    }
    print("rate", window.rate);
    calc();
  }
}
